import { MeetingCard } from "./MeetingCard";
import { Meeting } from "@/data/meetings";
import { DynamicLucideIcon } from "./DynamicLucideIcon";
import { generateCategoryId } from "@/utils/categoryId";

interface CategorySectionProps {
  category: string;
  meetings: Meeting[];
  icon?: string | null;
  color?: string | null;
}

export const CategorySection = ({
  category,
  meetings,
  icon = null,
  color = null,
}: CategorySectionProps) => {
  // Use utility function to generate consistent category ID
  const categoryId = generateCategoryId(category);

  // Use icon from backend if available, fallback to "Target"
  const iconName = icon || "Target";
  // Use color from backend if available, fallback to primary color
  const bgColor = color || "from-primary to-primary";
  return (
    <section id={categoryId} className="mb-12 animate-fade-in scroll-mt-24">
      <h2 className="text-2xl font-bold text-foreground mb-6 flex items-center gap-3">
        <div
          className={`w-10 h-10 rounded-lg bg-gradient-to-br ${bgColor} flex items-center justify-center`}
        >
          <DynamicLucideIcon
            name={iconName}
            className="w-5 h-5 text-white"
            fallback="CircleChevronRight"
          />
        </div>
        {category}
      </h2>
      <div className="flex overflow-x-auto gap-4 pb-4 snap-x snap-mandatory scrollbar-thin">
        {meetings.map((meeting) => (
          <div key={meeting.id} className="flex-none w-72 sm:w-80 snap-start">
            <MeetingCard
              id={meeting.id}
              name={meeting.name}
              category={meeting.category}
              level={meeting.level}
              openAccess={meeting.openAccess}
              premiumUnlocked={meeting.premiumUnlocked}
            />
          </div>
        ))}
      </div>
    </section>
  );
};
